module.exports = __webpack_public_path__ + "videos/tab-intelligence-video.b8aa602.mp4";